export default "__VITE_ASSET__e0f5b7a1__"